const Reflux = require("reflux");
const biAPI = require("app/util/api/bi-api");
const dateToUTCParam = require("./util/date-to-param").dateToUTCParam;

const ScheduledTasksActions = Reflux.createActions({
  "fetchData": { children: ["completed", "failed"] }
});

ScheduledTasksActions.fetchData.listen(function(period, users) {
  let params = {
    start_date: dateToUTCParam(period.startDate),
    end_date: dateToUTCParam(period.endDate),
    users: users
  };

  biAPI.fetch("/activities_rates", params, this.completed, this.failed);
});

module.exports = ScheduledTasksActions;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/actions/scheduled-tasks-actions.js